import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { querySiteTree } from '@api/api';
export default {
  data: function data() {
    return {
      siteId: '',
      siteName: '',
      selectId: '',
      selectName: '',
      showSite: false,
      expandedKeys: [],
      selectedKeys: [],
      searchValue: '',
      autoExpandParent: true,
      treeData: [],
      disabled: false,
      name: '',
      isLeaf: false
    };
  },
  props: {
    color: {
      typy: String,
      default: ''
    },
    status: {
      typy: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    this.loadTreeData();
  },
  methods: {
    // 确定
    selectSite: function selectSite() {
      this.siteId = this.selectId;
      this.siteName = this.selectName;
      var rex = /^[a-zA-Z]/;
      var type = '';
      var id = '';

      if (rex.test(this.siteId)) {
        type = '2';
        id = this.siteId.split('_')[1];
      } else {
        type = '1';
        id = this.siteId;
      }

      this.$emit('change', {
        id: id,
        type: type
      });
      this.showSite = false;
    },
    // 展开
    onExpand: function onExpand(expandedKeys) {
      console.log(expandedKeys, this.expandedKeys);
      var rex = /^[a-zA-Z]/;

      if (rex.test(expandedKeys)) {
        if (this.expandedKeys.includes(expandedKeys)) {
          this.expandedKeys.splice(this.expandedKeys.indexOf(expandedKeys), 1);
        } else {
          this.expandedKeys.push(expandedKeys);
        }
      }

      this.autoExpandParent = false;
    },
    // 选中
    onSelect: function onSelect(selectedKeys, e, data) {
      this.isLeaf = e.node.dataRef.isLeaf;

      if (data) {
        var record = data;
      } else {
        var record = e.node.dataRef;

        if (record.key.indexOf('_') != -1) {
          this.onExpand(record.key);
        }
      }

      this.selectId = record.key;
      this.selectName = record.title;
      this.selectedKeys = [record.key];
    },
    // 加载站点树
    loadTreeData: function loadTreeData() {
      var that = this;
      querySiteTree({
        addrType: 1,
        st: 52
      }).then(function (res) {
        if (res.success) {
          that.treeData = _toConsumableArray(res.result);
          that.siteId = that.treeData[0].key.split('_')[1];
          that.siteName = that.treeData[0].title;
          that.expandedKeys = [that.siteId];
          that.selectedKeys = [that.siteId];
          that.selectId = that.treeData[0].key.split('_')[1];
          that.selectName = that.treeData[0].title;
          that.$emit('change', {
            id: that.treeData[0].key.split('_')[1],
            type: '2'
          });
        }
      });
    },
    // 打开站点树
    openSiteBox: function openSiteBox() {
      this.showSite = !this.showSite;
    }
  }
};